import React from 'react';
import PropTypes from 'prop-types';
import {Select, Row, Col, Radio, DatePicker, message} from 'antd';
import {FormattedMessage, injectIntl} from 'react-intl';
import {withApollo} from 'react-apollo';
import Portlet from '../../utils/portlet';
import {
    leadGroupsQuery, leadGroupsVar, OS_GROUPS, BROWSER_GROUPS,
    TRAFFIC_CHANNELS, AFFILIATE_NETWORKS, DEVICE_TYPES, LEAD_COUNTRIES, CITIES
} from "./gql/query";
import LabelsFilter from "./labels-filter";
import moment from 'moment';

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const {RangePicker} = DatePicker;
const Option = Select.Option;


const parseRegions = data => {
  if(!data) return {}
  const res =  data.reduce((regions, { region, id: cityId }) => {
    if (regions[region.id]) regions[region.id].cityId.push(cityId);
    else {
      regions[region.id] = { ...region }
      regions[region.id].cityId = [cityId]
    }
    return regions
  }, {})
  return res}

const filterCitiesByRegion = (data, regionId) =>
  data.filter(({ region }) => ~regionId.indexOf(region.id))

/**
* Pure function returns date range
* @param SelectorValue{String}
* @return [dateFrom{moment}, dateTo{moment}]
* @public
*/
export const getDateRange = type => {
  const today = moment().utc();
  switch (type) {
    case "lastMonth":
      return [
        moment().utc().subtract(29, 'day').startOf('day'),
        today.endOf('day')
      ];
    case "thisWeek":
      return [
        moment().utc().isoWeekday(1).startOf('day'),
        today.endOf('day')
      ];
    case "lastWeek":
      return [
        moment().utc().isoWeekday(-6).startOf('day'),
        moment().utc().isoWeekday(0).endOf('day'),
      ];
    case "thisMonth":
      return [
        moment().utc().set('date', 1).startOf('day'),
        today.endOf('day')
      ];
    case "pastMonth":
      return [
        moment().utc().set('date', 1).subtract(1, 'month').startOf('day'),
        moment().utc().subtract(1, 'month').endOf('month')
      ];
    case "lastQr":
      return [
        moment().utc().subtract(89, 'day').startOf('day'),
        today.endOf('day')
      ];
    default:
      return null
  }
}


const METRICS = ['lead-age', 'lead-duration', 'consumer-origin', 'lead-lineage'];

class Filter extends React.Component {
  static propTypes = {
    metrics: PropTypes.array.isRequired,
    metric: PropTypes.string.isRequired,
    period: PropTypes.array.isRequired,
    selected: PropTypes.array,
    osGroupsSelected: PropTypes.array,
    browserGroupsSelected: PropTypes.array,
    trafficChannelsSelected: PropTypes.array,
    affiliateNetworksSelected: PropTypes.array,
    deviceTypesSelected: PropTypes.array,
    countrySelected: PropTypes.number,
    citiesSelected: PropTypes.array,
    regionsSelected: PropTypes.array,
    style: PropTypes.object,
    onPeriodChange: PropTypes.func,
    onMetricChange: PropTypes.func,
    onLeadGroupsChange: PropTypes.func,
    onOsGroupsChange: PropTypes.func,
    onBrowserGroupsChange: PropTypes.func,
    onTrafficChannelsChange: PropTypes.func,
    onAffiliateNetworksChange: PropTypes.func,
    onDeviceTypesChange: PropTypes.func,
    onUrlLabelsChange: PropTypes.func.isRequired,
    onCountryChange: PropTypes.func,
    onCitiesChange: PropTypes.func,
    onRegionChange: PropTypes.func,
  }

  constructor(props) {
    super(props);
    let state = {};
    for (let i = 0; i < METRICS.length; i++) {
      state[METRICS[i]] = null;
    }
    this.state = state;
  }

  getLeadGoupsOptions(groups) {
    return groups.map((group, i) => {
      return (<Option key={group.groupName}>{group.groupTitle}</Option>);
    });
  }

  getOsGoupsOptions(groups) {
    const {formatMessage, messages} = this.props.intl;
    return groups.map((group, i) => {
      const osName = 'analytics.os-' + group.name.toLowerCase() in messages ?
        formatMessage({id: 'analytics.os-' + group.name.toLowerCase(), defaultMessage: group.name}) :
        group.name;
      return (<Option key={group.id} value={group.id}>{osName}</Option>);
    });
  }

  getBrowserGroupsOptions(groups) {
    const {formatMessage, messages} = this.props.intl;
    return groups.map((group, i) => {
      const BrowserName = 'analytics.browser-' + group.name.toLowerCase() in messages ?
        formatMessage({id: 'analytics.browser-' + group.name.toLowerCase(), defaultMessage: group.name}) :
        group.name;
      return (<Option key={group.id} value={group.id}>{BrowserName}</Option>);
    });
  }

  getTrafficChannelsOptions(groups) {
    const {formatMessage, messages} = this.props.intl;
    return groups.map((group, i) => {
      const BrowserName = 'analytics.traffic-channel-' + group.name.toLowerCase() in messages ?
        formatMessage({
          id: 'analytics.traffic-channel-' + group.name.toLowerCase(),
          defaultMessage: group.name
        }) :
        group.name;
      return (<Option key={group.id} value={group.id}>{BrowserName}</Option>);
    });
  }

  getAffiliateNetworksOptions(affiliate_networks) {
    const {formatMessage, messages} = this.props.intl;
    return affiliate_networks.map((affiliate_network, i) => {
    const AffiliateNetworkName = 'analytics.affiliate-network-' + affiliate_network.nameEng.toLowerCase() in messages ?
        formatMessage({
          id: 'analytics.affiliate-network-' + affiliate_network.nameEng.toLowerCase(),
          defaultMessage: affiliate_network.nameEng
        }) :
        affiliate_network.nameEng;
      return (<Option key={affiliate_network.id} value={affiliate_network.id}>{AffiliateNetworkName}</Option>);
    });
  }

  getDeviceTypesOptions(device_types) {
      const {formatMessage, messages} = this.props.intl;
      return device_types.map((device_type, i) => {
          const DeviceTypeName = 'analytics.device-type-' + device_type.name.toLowerCase() in messages ?
              formatMessage({
                  id: 'analytics.device-type-' + device_type.name.toLowerCase(),
                  defaultMessage: device_type.name
              }) :
              device_type.name;
          return (<Option key={device_type.id} value={device_type.id}>{DeviceTypeName}</Option>);
      })
  }

  getCountriesOptions(countries) {
    const {formatMessage, messages} = this.props.intl;
    return countries.map((country, i) => {
      let parsed_country = JSON.parse(country);
      // const CountryName = 'analytics.country-' + country in messages ?
      //   formatMessage({
      //     id: 'analytics.country-' + country,
      //     defaultMessage: country
      //   }) :
      //   country;
      return (<Option key={parsed_country.id} value={parsed_country.id}>{parsed_country.name}</Option>);
    });
  }

  getRegionsOptions(regions = []){
    if(!regions.length) return []
    const {formatMessage, messages} = this.props.intl;
    const parsedRegions = parseRegions(regions)
    return Object.values(parsedRegions).map(region => {
      const regionName = 'analytics.regions-' + region.name in messages ?
        formatMessage({
          id: 'analytics.regions-' + region.name,
          defaultMessage: region
        }) :
        region.name;
      return (<Option key={region.id} value={region.id}>{regionName}</Option>);
    });

  }

  getCitiesOptions(cities, regionId) {
    const {formatMessage, messages} = this.props.intl;
    return filterCitiesByRegion(cities, regionId).map(city => {
      const cityName = 'analytics.cities-' + city.name in messages ?
        formatMessage({
          id: 'analytics.cities-' + city.name,
          defaultMessage: city
        }) :
        city.name;
      return (<Option key={city.id} value={city.id}>{cityName}</Option>);
    });
  }

  onMetricChange = (e) => {
    e.preventDefault();
    this.loadLeadGroups(e.target.value);
    this.props.onMetricChange(e.target.value);
  }

  handleInternalError = (err) => {
    const {formatMessage} = this.props.intl;
    message.error(formatMessage({
      id: 'general.network-error',
      defaultMessage: 'Network error, try again later'
    }));
  }

  loadLeadGroups(metric) {
    const metrics = this.props.metrics || METRICS;
    if (metrics.indexOf(metric) === -1) {
      return;
    }
    const query = leadGroupsQuery(metric);
    if (!query) {
      return;
    }

    if (this.state[metric] === null) {
      this.props.client
        .query({query})
        .then(({data}) => {
          let state = {};
          const resVar = leadGroupsVar(metric);
          state[metric] = data[resVar];
          this.setState(state);
        }).catch(this.handleInternalError);
    }
  }

  loadOsGroups(metric) {
    this.props.client
      .query({query: OS_GROUPS})
      .then(({data: {osGroups}}) => {
        this.setState({osGroups});
      }).catch(this.handleInternalError);

  }

  loadBrowserGroups(metric) {
    this.props.client
      .query({query: BROWSER_GROUPS})
      .then(({data: {browserGroups}}) => {
        this.setState({browserGroups});
      }).catch(this.handleInternalError);
  }

  loadTrafficChannels() {
    this.props.client
      .query({query: TRAFFIC_CHANNELS})
      .then(({data: {trafficChannels}}) => {
        this.setState({trafficChannels});
      }).catch(this.handleInternalError);
  }

  loadAffiliateNetworks() {
    this.props.client
      .query({
          query: AFFILIATE_NETWORKS,

      })
      .then(({data: {affiliateNetworks}}) => {
        this.setState({affiliateNetworks});
      }).catch(this.handleInternalError);

  }
  loadDeviceTypes() {
    this.props.client
      .query({query: DEVICE_TYPES})
      .then(({data: {deviceTypes}}) => {
        this.setState({deviceTypes});
      }).catch(this.handleInternalError);
  }

  loadCountries() {
    this.props.client
      .query({query: LEAD_COUNTRIES})
      .then(({data: {leadCountries}}) => {
        this.setState({countries: leadCountries});
      }).catch(this.handleInternalError);
  }

  loadCities() {
    if (this.props.countrySelected) {
        this.props.client
            .query({query: CITIES, variables: {country: this.props.countrySelected}})
            .then(({data: {cities, error}}) => {
                this.setState({cities});
            }).catch(this.handleInternalError);
    } else {
      this.setState({cities: []})
    }
  }

  componentDidUpdate(prevProps, prevState) {
      if (prevProps.countrySelected !== this.props.countrySelected) {
          this.loadCities()
      }
  }

  componentWillMount() {
    this.loadLeadGroups(this.props.metric);
    this.loadOsGroups();
    this.loadBrowserGroups();
    this.loadTrafficChannels();
    this.loadAffiliateNetworks();
    this.loadDeviceTypes();
    this.loadCountries();
    this.loadCities();
  }

  renderLeadGroups(metric) {
    const metrics = this.props.metrics || METRICS;
    if (metrics.indexOf(metric) === -1) {
      return '';
    }
    if (!leadGroupsQuery(metric)) {
      return '';
    }

    const {formatMessage} = this.props.intl;
    return (
      <label className='lead-groups' style={{display: 'flex', flexDirection: 'row', whiteSpace: 'nowrap'}}>
        <span className='label'>
          {formatMessage({id: 'analytics.groups', defaultMessage: 'Groups'})}:
        </span>
        <Select
          size='large'
          style={{flex: 'auto', minWidth: '300px'}}
          mode="multiple" placeholder={formatMessage({id: 'analytics.groups', defaultMessage: 'Groups'})}
          onChange={this.props.onLeadGroupsChange}
          value={this.props.selected}
        >
          {this.getLeadGoupsOptions(this.state[metric] || [])}
        </Select>
      </label>
    );
  }

  renderOsGroups() {
    const {formatMessage} = this.props.intl;
    return (
      <Select
        size='large'
        style={{marginBottom: '10px', minWidth: '300px', width: '100%'}}
        mode="multiple"
        placeholder={
          formatMessage({id: 'analytics.os-groups', defaultMessage: 'Operating system'})
        }
        onChange={this.props.onOsGroupsChange}
        value={this.props.osGroupsSelected}
      >
        {this.getOsGoupsOptions(this.state.osGroups || [])}
      </Select>
    )
  }

  renderBrowserGroups() {
    const {formatMessage} = this.props.intl;
    return (
      <Select
        size='large'
        style={{marginBottom: '10px', minWidth: '300px', width: '100%'}}
        mode="multiple"
        placeholder={
          formatMessage({id: 'analytics.browser-groups', defaultMessage: 'Browser group'})
        }
        onChange={this.props.onBrowserGroupsChange}
        value={this.props.browserGroupsSelected}
      >
        {this.getBrowserGroupsOptions(this.state.browserGroups || [])}
      </Select>
    )
  }

  renderTrafficChannels() {
    const {formatMessage} = this.props.intl;
    return (
      <Select
        size='large'
        style={{marginBottom: '10px', minWidth: '300px', width: '100%'}}
        mode="multiple"
        placeholder={
          formatMessage({id: 'analytics.traffic-channels', defaultMessage: 'Traffic channels'})
        }
        onChange={this.props.onTrafficChannelsChange}
        value={this.props.trafficChannelsSelected}
      >
        {this.getTrafficChannelsOptions(this.state.trafficChannels || [])}
      </Select>
    )
  }

  renderAffiliateNetworks() {
    const {formatMessage} = this.props.intl;
    return (
      <Select
        size='large'
        style={{marginBottom: '10px', minWidth: '300px', width: '100%'}}
        mode="multiple"
        placeholder={
          formatMessage({id: 'analytics.affiliate-networks', defaultMessage: 'Affiliate networks'})
        }
        onChange={this.props.onAffiliateNetworksChange}
        value={this.props.affiliateNetworksSelected}
      >
        {this.getAffiliateNetworksOptions(this.state.affiliateNetworks || [])}
      </Select>
    )
  }

  renderDeviceTypes() {
    const {formatMessage} = this.props.intl;
    return (
      <Select
        size='large'
        style={{marginBottom: '10px', minWidth: '300px', width: '100%'}}
        mode="multiple"
        placeholder={
          formatMessage({id: 'analytics.device-types', defaultMessage: 'Device types'})
        }
        onChange={this.props.onDeviceTypesChange}
        value={this.props.deviceTypesSelected}
      >
        {this.getDeviceTypesOptions(this.state.deviceTypes || [])}
      </Select>
    )
  }

  renderCountries() {
    const {formatMessage} = this.props.intl;
    return (
        <Select
          size='large'
          showSearch={true}
          style={{marginBottom: '10px', minWidth: '300px', width: '100%'}}
          allowClear={true}
          placeholder={
            formatMessage({id: 'analytics.country', defaultMessage: 'Country'})
          }
          onChange={this.props.onCountryChange}
          value={this.props.countrySelected}
          filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        >
          {this.getCountriesOptions(this.state.countries || [])}
        </Select>
    )
  }

  handleDatePicker = period => {
    period[1] = period[1].endOf('day');
    this.props.onPeriodChange(period, 'custom')
  };

  _getDateRanges = () => {
    const {formatMessage} = this.props.intl;
    // analytics.date-selector.lastMonth' defaulMessage='lastMonth'/>
    // analytics.date-selector.thisWeek' defaulMessage='thisWeek'/>
    // analytics.date-selector.lastWeek' defaulMessage='lastWeek'/>
    // analytics.date-selector.thisMonth' defaulMessage='thisMonth'/>
    // analytics.date-selector.pastMonth' defaulMessage='pastMonth'/>
    // analytics.date-selector.lastQr' defaulMessage='lastQr'/>
    // analytics.date-selector.custom' defaulMessage='custom'/>
    return {
      [formatMessage({
        id: 'analytics.date-selector.thisWeek', 
        defaultMessage: 'This week'
      })]: getDateRange('thisWeek'),
      [formatMessage({
        id: 'analytics.date-selector.lastWeek', 
        defaultMessage: 'Last week'
      })]: getDateRange('lastWeek'),
      [formatMessage({
        id: 'analytics.date-selector.thisMonth', 
        defaultMessage: 'This month'
      })]: getDateRange('thisMonth'),
      [formatMessage({
        id: 'analytics.date-selector.pastMonth', 
        defaultMessage: 'Last month'
      })]: getDateRange('pastMonth'),
      [formatMessage({
        id: 'analytics.date-selector.lastMonth', 
        defaultMessage: 'Last 30 days'
      })]: getDateRange('lastMonth'),
      [formatMessage({
        id: 'analytics.date-selector.lastQr', 
        defaultMessage: 'Last 90 days'
      })]: getDateRange('lastQr'),
    }
  }


  renderRegions() {
    const {formatMessage} = this.props.intl;
    return (
        <Select
          size='large'
          style={{marginBottom: '10px', minWidth: '300px', width: '100%'}}
          mode="multiple"
          placeholder={
            formatMessage({id: 'analytics.regions', defaultMessage: 'Regions'})
          }
          onChange={this.props.onRegionChange}
          value={this.props.regionsSelected}
          filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        >
          {this.getRegionsOptions(this.state.cities || [])}
        </Select>
    )
  }

  renderCities() {
    const {formatMessage} = this.props.intl;
    return (
        <Select
          size='large'
          style={{marginBottom: '10px', minWidth: '300px', width: '100%'}}
          mode="multiple"
          placeholder={
            formatMessage({id: 'analytics.cities', defaultMessage: 'Cities'})
          }
          onChange={this.props.onCitiesChange}
          value={this.props.citiesSelected}
          filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        >
          {this.getCitiesOptions(this.state.cities || [], this.props.regionsSelected)}
        </Select>
    )
  }

  render() {
    let {
      metrics, metric, style, regionsSelected, countrySelected,
      onUrlLabelsChange, period,
      labelType, labelValues, nav
    } = this.props;
    const {formatMessage} = this.props.intl;
    // period[1] = period[1].endOf('day');
    // period[0] = period[0].startOf('day');
    metrics = metrics || METRICS;
    if (metrics.length) {
      nav = (<Portlet style={style} className='metric-filter'>
        <RadioGroup defaultValue={metric} onChange={this.onMetricChange} size='small'>
          {
            metrics.map((metric) => (
                <RadioButton key={metric} value={metric}>
                  <FormattedMessage id={'analytics.' + metric}/>
                </RadioButton>
              )
            )
          }
        </RadioGroup>
      </Portlet>)
    } else {
      nav = ('')
    }
    return (<div>
        {nav}
        <div>
        <Row type="flex" justify="space-between" style={{margin: '10px 0'}}>
          <Col className="analytics__date-wrap">
            <RangePicker
              size='large'
              ranges={this._getDateRanges()}
              style={{width: '210px'}} onChange={this.handleDatePicker}
              defaultValue={period}  allowClear={false}
              value={period}
              format={this.props.intl.formatMessage({
                id: 'general.date-format',
                defaultMessage: 'YYYY-MM-DD'
              })}
              className="analytics__date-picker"
              dropdownClassName={`date-picker__${formatMessage({
                id: 'general.locale', 
                defaultMessage: 'en'
              })}`}
              showTime
            />
          </Col>
          <Col className='filter-groups-col'>
            {this.renderLeadGroups(metric)}
          </Col>
          <Col>
            {/*<Button size='large' className='export-csv-btn'>*/}
              {/*<FormattedMessage id='analytics.export-csv' defaulMessage='Export CSV'/>*/}
              {/*<Icon type="arrow-down"/>*/}
            {/*</Button>*/}
          </Col>
        </Row>
          <Row gutter={8}>
            <Col span={8}>
              {this.renderOsGroups()}
            </Col>
            <Col span={8}>
              {this.renderBrowserGroups()}
            </Col>
            <Col span={8}>
              {this.renderTrafficChannels()}
            </Col>
            <Col span={8}>
              {this.renderAffiliateNetworks()}
            </Col>
            <Col span={8}>
              {this.renderDeviceTypes()}
            </Col>
          </Row>
          <Row gutter={8}>
            <Col span={8}>
              {this.renderCountries()}
            </Col>
             {countrySelected &&
                <Col span={8}>
                    {this.renderRegions()}
                </Col>
             }
             {regionsSelected.length &&
                <Col span={8}>
                    {this.renderCities()}
                </Col>
             }
          </Row>
          <Row>
            <LabelsFilter
              labelType={labelType}
              labelValues={labelValues}
              onChange={onUrlLabelsChange}
            />
          </Row>
        </div>
      </div>
    );
  }
}


export default withApollo(injectIntl(Filter));


// {/*<RadioButton value='offer'>Offer</RadioButton>*/}
// {/*<RadioButton value='affiliate'>Affiliate</RadioButton>*/}
// {/*<RadioButton value='date'>Date</RadioButton>*/}
// {/*<RadioButton value='advertiser'>Advertiser</RadioButton>*/}
// {/*<RadioButton value='ip'>IP</RadioButton>*/}
// {/*<RadioButton value='ipd'>IP(D)</RadioButton>*/}
// {/*<RadioButton value='affiliate-sub1'>Affiliate sub1</RadioButton>*/}
// {/*<RadioButton value='affiliate-sub2'>Affiliate sub2</RadioButton>*/}
// {/*<RadioButton value='affiliate-sub3'>Affiliate sub3</RadioButton>*/}
// {/*<RadioButton value='affiliate-sub4'>Affiliate sub4</RadioButton>*/}
// {/*<RadioButton value='affiliate-sub5'>Affiliate sub5</RadioButton>*/}
// {/*<RadioButton value='referal-host'>Referal Host</RadioButton>*/}
// {/*<RadioButton value='source'>Source</RadioButton>*/}
// {/*<RadioButton value='country'>Country</RadioButton>*/}
// {/*<RadioButton value='isp'>ISP</RadioButton>*/}
// {/*<RadioButton value='city'>City</RadioButton>*/}
// {/*<RadioButton value='status'>Status</RadioButton>*/}
// {/*<RadioButton value='user-device'>User device</RadioButton>*/}
// {/*<RadioButton value='browser'>Browser</RadioButton>*/}
// {/*<RadioButton value='os-version'>OS version</RadioButton>*/}
// {/*<RadioButton value='os'>OS</RadioButton>*/}
// {/*<RadioButton value='hour'>Hour</RadioButton>*/}
// {/*<RadioButton value='fraud-status'>Fraud status</RadioButton>*/}
// {/*<RadioButton value='fraud-reason'>Fraud reason</RadioButton>*/}
// {/*<RadioButton value='time-to-install'>Time to install</RadioButton>*/}
// {/*<RadioButton value='android-id'>Android ID</RadioButton>*/}
// {/*<RadioButton value='idfa'>IDFA</RadioButton>*/}
// {/*<RadioButton value='email'>E-mail</RadioButton>*/}
// {/*<RadioButton value='connection-type'>Connection Type</RadioButton>*/}
// {/*<RadioButton value='device-brand'>Device brand</RadioButton>*/}
// {/*<RadioButton value='user-id'>User ID</RadioButton>*/}



// WEBPACK FOOTER //
// ./src/components/dashboard/analytics/filter.js